import { Route, Routes, useLocation } from '@solidjs/router';
import { createSignal, lazy, onMount, Show } from 'solid-js';
import { FullScreenLayout } from '~/components/layouts';
import { auth, correctActiveAccountForHost, redirectToAuth } from '~/config/auth';
import { AuthProvider } from '~/contexts/global';
import type { ParentComponent } from 'solid-js';

const SignInPage = lazy(() => import('~/pages/auth/SignIn'));
const ResetPasswordPage = lazy(() => import('~/pages/auth/ResetPassword'));
const MagicLinkPage = lazy(() => import('~/pages/auth/MagicLink'));
const CallbackPage = lazy(() => import('~/pages/auth/Callback'));
const HandoffPage = lazy(() => import('~/pages/auth/Handoff'));
const CrossHostSwitchPage = lazy(() => import('~/pages/auth/CrossHostSwitch'));

export const AuthGuard: ParentComponent = (props) => {
  const [isAuthenticated, setIsAuthenticated] = createSignal(false);
  const location = useLocation();

  const checkAuth = () => {
    if (location.pathname.startsWith('/auth')) return;

    if (!auth.storage.getTokenStorage().access_token) {
      redirectToAuth(encodeURIComponent(location.pathname + location.search), { reason: null });
      return;
    }

    const correction = correctActiveAccountForHost();
    if (correction === 'switched') {
      window.location.reload();
      return;
    }
    if (correction === 'needs-signin') {
      redirectToAuth(encodeURIComponent(location.pathname + location.search), { reason: null });
      return;
    }
    setIsAuthenticated(true);
  };

  onMount(() => {
    checkAuth();
  });

  return (
    <AuthProvider>
      <Routes>
        <Route path="/auth" component={FullScreenLayout}>
          <Route path="signin" component={SignInPage} />
          <Route path="reset-password" component={ResetPasswordPage} />
          <Route path="magic-link" component={MagicLinkPage} />
          <Route path="callback" component={CallbackPage} />
          <Route path="handoff" component={HandoffPage} />
          <Route path="switch" component={CrossHostSwitchPage} />
        </Route>
      </Routes>
      <Show when={isAuthenticated()}>{props.children}</Show>
    </AuthProvider>
  );
};
